import { createContext } from 'react';
import { OrderDetailContextType } from '../type/orderDetail';
import { AnyObject } from '../../../../commons';

export const OrderDetailContext = createContext<OrderDetailContextType | AnyObject>({});
